import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import InlineSvg from '../InlineSvg'
import { downloadImage } from '../../utils/local-image'
import OptionsPopoverItem from './OptionsPopoverItem'
import {
  getTranslation,
  getBaseModel,
  getComponent
} from '../../utils/bike-schema'
import RenderTable from './../RenderTable'
import RenderPendix from './../RenderPendix'
import { t } from '../../utils/i18n'
import Popover from '../Popover'
import { optionClicked } from '../../actions'
import { getChoice } from '../../utils/bike-config'

const checkLack = (prompt) => {
  if (prompt) {
    const component = Object.keys(prompt)
    let lack = true
    prompt[component].forEach((choice) => {
      const check = `${component}=${choice}`
      if (window.location.href.search(check) > 0) {
        lack = false
      }
    })
    return lack
  }
  return false
}

const OptionsPopover = () => {
  const dispatch = useDispatch()
  const currencyCode = useSelector((state) => state.currencyCode)
  const bikeConfig = useSelector((state) => state.bikeConfig)
  const componentId = useSelector((state) => state.options.componentId)

  const baseModel = getBaseModel(bikeConfig.baseModelId)
  const component = getComponent(baseModel, componentId)
  const choice = getChoice(bikeConfig, component)
  const currentPrice = choice.option.price
    ? choice.option.prices[currencyCode]
    : 0
  let options = component.options
    .map((option) => {
      if (option.hidden === true) return null
      else if (typeof option.hidden === 'object') {
        let isHidden = false
        for (const key in option.hidden) {
          const foundChoice = getChoice(
            bikeConfig,
            getComponent(baseModel, key)
          ).option.id
          option.hidden[key].forEach((item) => {
            if (item == foundChoice) isHidden = true
          })
        }
        if (isHidden) return null
        else
          return {
            option,
            active: choice && choice.option.id == option.id,
            name: getTranslation(option.name),
            priceDiff:
              (option.price ? option.prices[currencyCode] : 0) - currentPrice,
            sold: option.sold || false
          }
      } else
        return {
          option,
          active: choice && choice.option.id == option.id,
          name: getTranslation(option.name),
          priceDiff:
            (option.price ? option.prices[currencyCode] : 0) - currentPrice,
          sold: option.sold || false
        }
    })
    .filter((el) => el != null)

  const isLack = checkLack(component.prompt)
  const [visible, setVisible] = useState(false)
  const [pendixVisible, setPendixVisible] = useState(false)
  const displayTooltip = pendixVisible

  return (
    <Popover
      className="velorbis-customizer-option-list"
      alignTo={`.velorbis-customizer-component[data-component="${component.id}"]`}
    >
      <div className="velorbis-customizer-popover-header">
        {getTranslation(component.name)}
        {component.id === 'frame-size' && (
          <div className="tooltip" onMouseEnter={() => setVisible(true)}>
            &#9432;
          </div>
        )}
        {component.id === 'electric-motor' && (
          <div className="inline-block">
            <div className="download-icon" onClick={downloadImage}>
              <InlineSvg src="icons/download" />
              <div></div>
            </div>
            <div
              className="tooltip"
              onMouseEnter={() => setPendixVisible(true)}
            >
              &#9432;
            </div>
          </div>
        )}
      </div>
      {visible && (
        <div className="tooltip-content">
          <div className="gearstable-wrapper">
            <button className="close-button" onClick={() => setVisible(false)}>
              X
            </button>
            <RenderTable />
          </div>
        </div>
      )}
      {displayTooltip && (
        <div className="tooltip-content">
          <div className="pendix-wrapper">
            <button
              className="close-button"
              onClick={() => setPendixVisible(false)}
            >
              X
            </button>
            <RenderPendix />
          </div>
        </div>
      )}
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-no-padding">
        {isLack ? (
          <div className="velorbis-customizer-leather">
            {t(`${component.id}_prompt`)}
          </div>
        ) : (
          options.map((item) => (
            <OptionsPopoverItem
              key={item.option.id}
              hidePrice={component.hide_price}
              baseModelId={bikeConfig.baseModelId}
              currencyCode={currencyCode}
              {...item}
              onClick={() =>
                dispatch(optionClicked(component.id, item.option.id))
              }
            />
          ))
        )}
      </div>
    </Popover>
  )
}

export default OptionsPopover
